export const TIPOLOGIA_ORARIO = {
  CONVIVENZA: 1,
  CONVIVENZA_RIDOTTA: 2,
  NON_CONVIVENTE: 3,
  PRESENZA_NOTTURNA: 4,
  WEEKEND: 5,
  ASSISTENZA_NOTTURNA: 6,
};
